export function useLatinKeyboardGroupProps() {
  return { containerProps: {} };
}
